// extracted by mini-css-extract-plugin
export default {"wrapper":"designations_wrapper__2iPNr"};